import {
  fetchSnmp,
  saveSnmp,
  testSnmpTrap
} from './api';

export const FETCH_SNMP = 'FETCH_SNMP';
export const FETCH_SNMP_SUCCESS = 'FETCH_SNMP_SUCCESS';
export const FETCH_SNMP_ERROR = 'FETCH_SNMP_ERROR';
export const SAVE_SNMP = 'SAVE_SNMP';
export const TEST_SNMP_TRAP = 'TEST_SNMP_TRAP';

const getInitialState = () => ({
  traps: {
    community: '',
    ip: '',
    port: '162',
    enabled: false
  },
  enabled: false
});

export const snmp = {
  namespaced: true,
  state: getInitialState,
  mutations: {
    [FETCH_SNMP_SUCCESS](state, payload) {
      state.enabled = payload.enabled;
      state.traps = payload.traps;
    },
    [FETCH_SNMP_ERROR](state) {
      state.enabled = false;
    },
    FLUSH_STATE(state) {
      Object.assign(state, getInitialState());
    },
  },
  actions: {
    [FETCH_SNMP](context) {
      return fetchSnmp(this.$api)
        .then((response) => {
          if (response && response.data) {
            context.commit(FETCH_SNMP_SUCCESS, response.data);
          } else {
            context.commit(FETCH_SNMP_ERROR);
          }
          return response;
        })
        .catch((error) => {
          context.commit(FETCH_SNMP_ERROR, error && error.data);
          throw error;
        });
    },
    [SAVE_SNMP]({ commit }, payload) {
      return saveSnmp(this.$api, payload)
        .then((response) => {
          commit(FETCH_SNMP_SUCCESS, payload);
          return response;
        });
    },
    [TEST_SNMP_TRAP](_, payload) {
      return testSnmpTrap(this.$api, payload);
    }
  }
};
